import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onBlur", "onFocus"];
import { forwardRef, useCallback, useRef } from 'react';
import { useTouchListener } from './useTouchListener';
import { jsx as _jsx } from "react/jsx-runtime";
const identity = () => {};
const withBlurHandler = WrappedComponent => {
  var _WrappedComponent$dis;
  const Component = /*#__PURE__*/forwardRef((props, ref) => {
    const _ref2 = props,
      {
        onBlur: parentOnBlur = identity,
        onFocus: parentOnFocus = identity
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
    const _ref = useRef(null);
    const inputRef = typeof ref !== 'function' && ref || _ref;
    const targetRef = useRef(null);
    const onTouchEvent = useCallback(e => {
      if (targetRef.current && e.target !== targetRef.current) {
        if (inputRef.current) {
          inputRef.current.blur();
        }
        targetRef.current = null;
        return false;
      }
      return Boolean(targetRef.current);
    }, [inputRef]);
    useTouchListener(onTouchEvent);
    const onBlur = e => {
      targetRef.current = null;
      parentOnBlur(e);
    };
    const onFocus = e => {
      if (e.target) {
        targetRef.current = e.target;
      }
      parentOnFocus(e);
    };
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, rest, {
      ref: inputRef,
      onFocus: onFocus,
      onBlur: onBlur
    }));
  });
  Component.displayName = `withBlurHandler(${(_WrappedComponent$dis = WrappedComponent.displayName) !== null && _WrappedComponent$dis !== void 0 ? _WrappedComponent$dis : WrappedComponent.name})`;
  return Component;
};
export default withBlurHandler;